import { withDependencies } from '@wix/thunderbolt-ioc'
import { IShouldNavigateHandler } from '../types'

export const ShouldNavigateHandler = withDependencies(
	[],
	(): IShouldNavigateHandler => {
		return {
			shouldNavigate: (linkProps) => {
				const { target, type } = linkProps
				if (type === 'ExternalLink' && target === '_self') {
					return false
				}
				if (type === 'EmailLink') {
					return false
				}
				if (
					target === '_blank' &&
					(type === 'PageLink' || type === 'AnchorLink' || type === 'DynamicPageLink')
				) {
					return false
				}

				return true
			},
		}
	}
)
